/**
 * Created by jiachenpan on 16/11/18.
 */
import {
  Toast
} from 'vant'
import moment from 'moment'
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
export function hangeUnit(value) {

  let numerical = [];
  let k = 10000,
    sizes = ['', '万', '亿', '万亿'],
    i;
  if (value < k) {
    numerical = Number(value).toFixed(2)
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    numerical = ((value / Math.pow(k, i))).toFixed(2) + sizes[i];
  }

  return numerical;

  // let newValue = ['', '', ''];
  // let fr = 1000;
  // const ad = 1;
  // let num = 3;
  // const fm = 1;
  // while (value / fr >= 1) {
  //   fr *= 10;
  //   num += 1;
  //   // console.log('数字', value / fr, 'num:', num);
  // }
  // if (num <= 4) { // 千
  //   newValue[1] = '千';
  //   newValue[0] = parseInt(value / 1000) + '';
  // } else if (num <= 8) { // 万
  //   const text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万';
  //   // tslint:disable-next-line:no-shadowed-variable
  //   const fm = '万' === text1 ? 10000 : 10000000;
  //   newValue[1] = text1;
  //   newValue[0] = (value / fm) + '';
  // } else if (num <= 16) { // 亿
  //   let text1 = (num - 8) / 3 > 1 ? '千亿' : '亿';
  //   text1 = (num - 8) / 4 > 1 ? '万亿' : text1;
  //   text1 = (num - 8) / 7 > 1 ? '千万亿' : text1;
  //   // tslint:disable-next-line:no-shadowed-variable
  //   let fm = 1;
  //   if ('亿' === text1) {
  //     fm = 100000000;
  //   } else if ('千亿' === text1) {
  //     fm = 100000000000;
  //   } else if ('万亿' === text1) {
  //     fm = 1000000000000;
  //   } else if ('千万亿' === text1) {
  //     fm = 1000000000000000;
  //   }
  //   newValue[1] = text1;
  //   newValue[0] = parseInt(value / fm) + '';
  // }
  // if (value < 1000) {
  //   newValue[1] = '';
  //   newValue[0] = value + '';
  // }
  // return newValue.join('');
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// js将数字转换成万、亿、万亿
export function numberFormat(value) {
  var param = {};
  var k = 10000,
    sizes = ['', '万', '亿', '万亿'],
    i;
  if (value < k) {
    param.value = value
    param.unit = ''
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    param.value = ((value / Math.pow(k, i))).toFixed(2);
    param.unit = sizes[i];
  }
  return param;
}

// js将数字转换成万 并且保留两位小数
export const keepTwoDecimalFull = (num) => {
  if (num > 10000) {
    let result = num / 10000;
    result = Math.floor(result * 100) / 100;
    var s_x = result.toString(); //将数字转换为字符串
    var pos_decimal = s_x.indexOf('.'); //小数点的索引值
    // 当整数时，pos_decimal=-1 自动补0
    if (pos_decimal < 0) {
      pos_decimal = s_x.length;
      s_x += '.';
    }
    // 当数字的长度< 小数点索引+2时，补0
    while (s_x.length <= pos_decimal + 2) {
      s_x += '0';
    }
    s_x += '万';
  } else {
    s_x = num;
  }
  return s_x
}


export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}



export function filters(value, num) {
  if (!value) return ''
  if (value.length > num) {
    return value.slice(0, num) + '...'
  }
  return value
}

export function countDown(end_time) {
  if (end_time == null) return;
  let nowTime = moment().locale('zh-cn').format('YYYY-MM-DD HH:mm:ss'); //当前时间
  let endTime = moment(end_time).locale('zh-cn').format('YYYY-MM-DD HH:mm:ss');
  return moment(endTime).diff(moment(nowTime), 'seconds'); //剩余可倒计时的秒数 
}

export function initcountDown(endTime) {
  let time = moment(endTime).diff(moment())
  let t = time / 1000;
  let d = Math.floor(t / (24 * 3600)); //剩余天数，如果需要可以自行补上
  let h = Math.floor((t - 24 * 3600 * d) / 3600) + d * 24; //不需要天数，把天数转换成小时
  let _h = Math.floor((t - 24 * 3600 * d) / 3600) //保留天数后得小时
  let m = Math.floor((t - 24 * 3600 * d - _h * 3600) / 60);
  let s = Math.floor((t - 24 * 3600 * d - _h * 3600 - m * 60));
  let nh = String(h).length == 1 ? '0' + String(h) : String(h)
  let nm = String(m).length == 1 ? '0' + String(m) : String(m)
  let ns = String(s).length == 1 ? '0' + String(s) : String(s)
  let obj = {
    d: d,
    h: _h,
    m: m,
    s: s
  }
  // `${d}天${_h}时${m}分${s}秒`
  return obj

}